import axios from "axios";

export class ChangePasswordService {
    changePassword(username, oldPassword, newPassword) {
        let formData = {
            userName: username,
            oldPassword: oldPassword,
            password: newPassword
        };
        return axios.post('/appapv/changePassword.action', formData, {
            credentials: 'same-origin',
            params: {}
        }).then(res => res.data);
    }
}